const config = {
  BASE_API_URL: process.env.NEXT_PUBLIC_BASE_API_URL,
  BASE_URL: process.env.NEXT_PUBLIC_ORIGIN,
};

export default config;
